<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    :nudge-right="40"
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-btn v-if="button" readonly v-on="on" color="#062b48" dark block>{{
        dateFormatted
      }}</v-btn>
      <v-text-field
        v-else
        v-model="dateFormatted"
        :label="label"
        readonly
        v-on="on"
        outlined
        :rules="rules"
        :dense="dense"
        :class="className"
        :hide-details="hideDetails"
        background-color="#fff"
      ></v-text-field>
    </template>
    <v-date-picker
      v-bind="$attrs"
      v-on="$listeners"
      :min="button || backFill ? null : minDate"
      :value="value"
      :hide-details="hideDetails"
      :dense="dense"
      @input="emitChange"
    ></v-date-picker>
  </v-menu>
</template>

<script>
import moment from "moment";
export default {
  inheritAttrs: false,
  props: {
    hideDetails:{type:String, default: ''},
    value: { type: String, default: null },
    label: { type: String, default: "Select date" },
    dense: { type: Boolean, default: true },
    rules: { type: Array, default: () => [] },
    button: { type: Boolean, default: false },
    backFill: { type: Boolean, default: false },
    minDate: { type: String, default: moment().format("YYYY-MM-DD") },
    className: { type: String, default: "" },
  },
  data() {
    return {
      menu: false,
    };
  },
  computed: {
    dateFormatted() {
      if (this.value == null) return null;
      return moment(this.value, "YYYY-MM-DD").format("Do MMM YYYY");
    },
  },
  methods: {
    emitChange(v) {
      this.$emit("input", v);
      this.menu = false;
    },
  },
};
</script>

<style>
</style>